var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#545AA3",
    d: "M26.15 20.215l10.47 7.36a2.002 2.002 0 01-.035 3.297l-10.47 7.035A2 2 0 0123 36.247V21.85a2 2 0 013.15-1.636z",
    fillRule: "evenodd"
  })));
}

export default SvgPlayIcon;